"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObject = void 0;
var tslib_1 = require("tslib");
var IkeObject = /** @class */ (function () {
    function IkeObject() {
    }
    /**
     * Copy Keys from src into dest omitting any null or undefined values
     *
     * @param dest the destination object to copy into
     * @param src the source object to copy from
     * @returns nothing as the destination object is updated.
     */
    IkeObject.assignNotNull = function (dest, src) {
        var e_1, _a;
        try {
            for (var _b = tslib_1.__values(Object.keys(src)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                var value = src[key];
                if (value == null) {
                    continue;
                }
                dest[key] = value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return IkeObject;
}());
exports.IkeObject = IkeObject;
//# sourceMappingURL=object.js.map